import { Paper, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconChartLine } from '@tabler/icons-react';

export function AnalysisEmptyState(): JSX.Element {
  return (
    <Paper p="xl" withBorder radius="md" style={{ minHeight: 300 }}>
      <Stack align="center" justify="center" gap="md" h="100%" mih={250}>
        <ThemeIcon size={64} radius="md" variant="light" color="blue" style={{ opacity: 0.7 }}>
          <IconChartLine size={40} />
        </ThemeIcon>
        <Stack align="center" gap="xs">
          <Text size="xl" fw={600}>Select data to analyze</Text>
          <Text size="sm" c="dimmed" ta="center" maw={400}>
            Toggle measurements, dosing, or events from the sidebar to start exploring correlations
          </Text>
        </Stack>
      </Stack>
    </Paper>
  );
}
